import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
	selector: 'app-view-underwriting',
	templateUrl: './view-underwriting.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./view-underwriting.component.scss'],
	imports: [ReactiveFormsModule, FormsModule],
})
export class ViewUnderwritingComponent implements OnInit {
	applicantType: string;
	applicationID: string;
	constructor(private apiService: LegacyApiService) {}

	ngOnInit(): void {}
	createUnderwriting(applicantType, applicationID) {
		//redirect to underwriting page
	}
	editUnderwriting(applicantType, applicationID) {
		//redirect to underwriting page
	}
	deleteUnderwritingEntry(applicantType, applicationID) {
		this.apiService
			.deleteUnderwritingEntry(applicantType, applicationID)
			.subscribe((res) => {
				console.log(res);
				if (res['status']) alert('Underwriting deleted ');
				else alert('Failed to delete Underwriting');
			});
	}
}
